import { render, staticRenderFns } from "./ListReports.vue?vue&type=template&id=3ac89572&scoped=true&"
import script from "./ListReports.vue?vue&type=script&lang=ts&"
export * from "./ListReports.vue?vue&type=script&lang=ts&"
import style0 from "./ListReports.vue?vue&type=style&index=0&id=3ac89572&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac89572",
  null
  
)

export default component.exports